import icons_beacon from '../../images/Beacon.png';

const Beacon = (props) => {
    const { width, height, action } = props
    const fill = action ? "#202020" : "#7D86A9"
    // #7D86A9
    return (
        <img width={width} height={height} alt="" src={icons_beacon}>

            {/* <title>A7693652-6A2B-4B9A-92B5-E438EF4A8F14</title>
            <desc>Created with sketchtool.</desc>
            <g id="🧑🏻‍💻-Analytics-Tools" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="1.1-Analytics-Service" transform="translate(-23.000000, -281.000000)" fill={fill} fillRule="nonzero">
                    <g id="sidemenu" transform="translate(0.000000, 161.000000)">
                        <g id="item" transform="translate(23.000000, 120.000000)">
                            <g id="ic_manage_app">
                                <path d="M15.199986,0.187532932 L0.800013951,0.187532932 C0.357142857,0.187532932 0,0.544675789 0,0.987546882 L0,15.387519 C0,15.8303901 0.357142857,16.1875329 0.800013951,16.1875329 L15.199986,16.1875329 C15.6428571,16.1875329 16,15.8303901 16,15.387519 L16,0.987546882 C16,0.544675789 15.6428571,0.187532932 15.199986,0.187532932 Z M5.86785017,11.7411044 L4.44642857,11.7411044 L4.44642857,4.6339615 L5.86785017,4.6339615 L5.86785017,11.7411044 Z M11.5571289,11.7411044 L7.28927176,11.7411044 L7.28927176,10.3196828 L11.5571289,10.3196828 L11.5571289,11.7411044 Z M11.5571289,8.89826117 L7.28927176,8.89826117 L7.28927176,7.47680469 L11.5571289,7.47680469 L11.5571289,8.89826117 Z M11.5571289,6.05182562 L7.28927176,6.05182562 L7.28927176,4.63040403 L11.5571289,4.63040403 L11.5571289,6.05182562 Z" id="e"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g> */}
        </img>

    )
}

export default Beacon